import React, { Component } from 'react';

export default class CouponCellRenderer extends Component {
  render() {
    const CheckValid = () => {
      return (
        <i
          style={{
            fontSize: 15,
            color: 'green',
          }}
          className="fa fa-check-circle-o"
          aria-hidden="true"
        />
      );
    };
    const CheckInvalid = () => {
      return (
        <i
          style={{
            fontSize: 15,
            color: 'red',
          }}
          className="fa fa-times-circle-o"
          aria-hidden="true"
        />
      );
    };
    const { data } = this.props;
    const array = data.operatorsPaymentSale || [];
    return (
      <div>
        {array &&
          array.length > 0 &&
          array.map(({ coupon }, index) => {
            if (coupon) {
              return <CheckValid key={index} />;
            } else {
              return <CheckInvalid key={index} />;
            }
          })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CellRenderer/CouponCellRenderer.jsx